import React from 'react';
import {
  Divider,
  EmptyView,
  Flex,
  IconBlind,
  List,
  PrimaryButton,
  Spinner,
} from '@banhala/ui-kit';
import { useGoodsReviews } from '../../queries/useGoodsReviews';
import { ReviewCard } from './ReviewCard';
import { useAppDownloadModal } from 'shared/src/hooks';
import { useGoodsBasic } from '../../../../../../queries/useGoodsBasic';

/**
 * NOTE: BYBLY 마켓의 상품은 리뷰 최신순으로 정렬 요청 대응
 * https://ablycorp.slack.com/archives/C0AQPPEFK5G/p1776993032549279
 */
const FORCE_REVIEW_LATEST_ORDER_MARKET_SNO = 113357;

const ReviewListContent: React.FC = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const marketSno = goodsBasic?.market.sno;

  const { data: goodsReviews } = useGoodsReviews({
    order:
      FORCE_REVIEW_LATEST_ORDER_MARKET_SNO === marketSno ? 'LATEST' : undefined,
  });

  const { show: openModal } = useAppDownloadModal();

  if (goodsReviews.reviews.length === 0) {
    return (
      <Flex.Center height={200}>
        <EmptyView title={'아직 등록된 리뷰가 없어요'} icon={<IconBlind />} />
      </Flex.Center>
    );
  }

  return (
    <List
      data={goodsReviews.reviews}
      scrollEnabled={false}
      renderItem={({ item }) => <ReviewCard review={item} />}
      ItemSeparatorComponent={() => <Divider size={'medium'} />}
      ListFooterComponent={() => (
        <Flex padding={{ horizontal: 14 }}>
          <PrimaryButton
            variant={'fill'}
            size={'medium'}
            outline
            onPress={() => {
              openModal();
            }}
          >
            앱에서 리뷰 전체보기
          </PrimaryButton>
        </Flex>
      )}
    />
  );
};
export const ReviewList: React.FC = props => {
  return (
    <React.Suspense
      fallback={
        <Flex.Center height={300}>
          <Spinner size={24} />
        </Flex.Center>
      }
    >
      <ReviewListContent {...props} />
    </React.Suspense>
  );
};
